import { Allocation, Statistic, PortfolioBreakdown } from './interfaces'
export const ALLOCATION: Allocation = {
	allocation_id: 0,
	allocation_percentage: 0,
	allocation_value: 0,
	categories: [
    {
      "category_id": 1,
      "category_name": "Money Market",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 1,
          "asset_name": "Tax-Free Cash",
          "asset_ticker": "VMSXX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 2,
          "asset_name": "Taxable Cash",
          "asset_ticker": "VMFXX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        }
      ]
    },
    {
      "category_id": 2,
      "category_name": "Fixed Income",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 3,
          "asset_name": "Corporate Bonds",
          "asset_ticker": "XCB.TO",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 4,
          "asset_name": "Emerging Markets Debt",
          "asset_ticker": "MSD",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 5,
          "asset_name": "Government Bonds",
          "asset_ticker": "SNSXX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 6,
          "asset_name": "High Yield Bonds",
          "asset_ticker": "JNK",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 7,
          "asset_name": "Municipal Bonds",
          "asset_ticker": "LMBIX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        },
        {
          "asset_id": 8,
          "asset_name": "International Fixed Income",
          "asset_ticker": "SEFIX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 6
        },
        {
          "asset_id": 9,
          "asset_name": "U.S. Treasury (1-3 Years)",
          "asset_ticker": "SHY",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 7
        },
        {
          "asset_id": 10,
          "asset_name": "U.S. Treasury (1-10 Years)",
          "asset_ticker": "IEF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 8
        }
      ]
    },
    {
      "category_id": 3,
      "category_name": "Hard Assets",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 11,
          "asset_name": "Commodities",
          "asset_ticker": "DBC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 12,
          "asset_name": "Global Timber & Forestry Index",
          "asset_ticker": "WOOD",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 13,
          "asset_name": "Gold Index",
          "asset_ticker": "IAU",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        }
      ]
    },
    {
      "category_id": 4,
      "category_name": "Domestic Equities",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 14,
          "asset_name": "Transportation Index",
          "asset_ticker": "IYT",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 20
        },
        {
          "asset_id": 15,
          "asset_name": "Large Cap Growth",
          "asset_ticker": "IWF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 16,
          "asset_name": "Large Cap Value",
          "asset_ticker": "IWD",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 17,
          "asset_name": "Mid Cap Growth",
          "asset_ticker": "IWP",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 18,
          "asset_name": "Mid Cap Value",
          "asset_ticker": "IWS",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 19,
          "asset_name": "S&P 500",
          "asset_ticker": "IVV",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        },
        {
          "asset_id": 20,
          "asset_name": "Small Cap Growth",
          "asset_ticker": "IWO",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 6
        },
        {
          "asset_id": 21,
          "asset_name": "Small Cap Value",
          "asset_ticker": "IWN",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 7
        },
        {
          "asset_id": 22,
          "asset_name": "Specialty Energy",
          "asset_ticker": "XLE",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 8
        },
        {
          "asset_id": 23,
          "asset_name": "Specialty Financial",
          "asset_ticker": "XLF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 9
        },
        {
          "asset_id": 24,
          "asset_name": "Specialty Health",
          "asset_ticker": "XLV",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 10
        },
        {
          "asset_id": 25,
          "asset_name": "Specialty Metals & Mining",
          "asset_ticker": "XME",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 11
        },
        {
          "asset_id": 26,
          "asset_name": "Specialty Technology",
          "asset_ticker": "XLK",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 12
        },
        {
          "asset_id": 27,
          "asset_name": "Specialty Utilities",
          "asset_ticker": "XLU",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 13
        },
        {
          "asset_id": 28,
          "asset_name": "Broad REIT Index",
          "asset_ticker": "IYR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 14
        },
        {
          "asset_id": 29,
          "asset_name": "Consumer Staples",
          "asset_ticker": "XLP",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 15
        },
        {
          "asset_id": 30,
          "asset_name": "Industrial Metals",
          "asset_ticker": "DBB",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 16
        },
        {
          "asset_id": 31,
          "asset_name": "Large Cap Blend",
          "asset_ticker": "IWB",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 17
        },
        {
          "asset_id": 32,
          "asset_name": "Master Limited Partnerships",
          "asset_ticker": "AMLP",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 18
        },
        {
          "asset_id": 33,
          "asset_name": "Mid Cap Blend",
          "asset_ticker": "IWR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 19
        },
        {
          "asset_id": 34,
          "asset_name": "Preferred Stocks Index",
          "asset_ticker": "PFF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 21
        },
        {
          "asset_id": 35,
          "asset_name": "Small Cap Blend",
          "asset_ticker": "IWM",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 22
        },
        {
          "asset_id": 107,
          "asset_name": "Meta Platforms Inc",
          "asset_ticker": "META",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 23
        },
        {
          "asset_id": 108,
          "asset_name": "Apple Inc",
          "asset_ticker": "AAPL",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 24
        },
        {
          "asset_id": 109,
          "asset_name": "Microsoft Corp",
          "asset_ticker": "MSFT",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 25
        },
        {
          "asset_id": 110,
          "asset_name": "Alphabet Inc",
          "asset_ticker": "GOOGL",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 26
        },
        {
          "asset_id": 111,
          "asset_name": "Amazon.com Inc",
          "asset_ticker": "AMZN",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 27
        },
        {
          "asset_id": 112,
          "asset_name": "NVIDIA Corp",
          "asset_ticker": "NVDA",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 28
        },
        {
          "asset_id": 113,
          "asset_name": "UnitedHealth Group Inc",
          "asset_ticker": "UNH",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 29
        },
        {
          "asset_id": 114,
          "asset_name": "Berkshire Hathaway Inc",
          "asset_ticker": "BRK.A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 30
        }
      ]
    },
    {
      "category_id": 5,
      "category_name": "International Equities",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 36,
          "asset_name": "Emerging Markets Equity",
          "asset_ticker": "EEM",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 37,
          "asset_name": "International Equity",
          "asset_ticker": "EFA",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 38,
          "asset_name": "Japan",
          "asset_ticker": "EWJ",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 39,
          "asset_name": "Asia/Pacific Rim",
          "asset_ticker": "AAXJ",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 40,
          "asset_name": "Latin America",
          "asset_ticker": "ILF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        }
      ]
    },
    {
      "category_id": 6,
      "category_name": "Utilities",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 41,
          "asset_name": "American Electric Power",
          "asset_ticker": "AEP",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 42,
          "asset_name": "Consolidated Edison, Inc.",
          "asset_ticker": "ED",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 43,
          "asset_name": "Dominion Resources, Inc.",
          "asset_ticker": "D",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 44,
          "asset_name": "Entergy Corporation",
          "asset_ticker": "ETR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 45,
          "asset_name": "Exelon Corporation",
          "asset_ticker": "EXC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        },
        {
          "asset_id": 46,
          "asset_name": "FirstEnergy Corporation",
          "asset_ticker": "FE",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 6
        },
        {
          "asset_id": 47,
          "asset_name": "Nextera Energy",
          "asset_ticker": "NEE",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 7
        },
        {
          "asset_id": 48,
          "asset_name": "Portland General Electric",
          "asset_ticker": "POR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 8
        },
        {
          "asset_id": 49,
          "asset_name": "PPL Corporation",
          "asset_ticker": "PPL",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 9
        }
      ]
    },
    {
      "category_id": 7,
      "category_name": "Senior Rate Floating Notes",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 50,
          "asset_name": "BlackRock Floating Rate",
          "asset_ticker": "BGT",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 51,
          "asset_name": "BlackRock Ltd. Duration Income",
          "asset_ticker": "BLW",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 52,
          "asset_name": "Eaton Vance Floating Rate",
          "asset_ticker": "EVBLX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 53,
          "asset_name": "Eaton Vance Senior Floating-Rate",
          "asset_ticker": "EFR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 54,
          "asset_name": "Apollo Senior Floating Rate Fund Inc.",
          "asset_ticker": "AFT",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        },
        {
          "asset_id": 55,
          "asset_name": "Nuveen Floating Rate Income",
          "asset_ticker": "JFR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 6
        },
        {
          "asset_id": 56,
          "asset_name": "Nuveen Floating Rate Opportunity",
          "asset_ticker": "JRO",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 7
        },
        {
          "asset_id": 57,
          "asset_name": "Pioneer Floating Rate Trust",
          "asset_ticker": "PHD",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 8
        },
        {
          "asset_id": 58,
          "asset_name": "Saba Capital Income & Opportunities Fund",
          "asset_ticker": "BRW",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 9
        },
        {
          "asset_id": 59,
          "asset_name": "MFS Charter Income Trust",
          "asset_ticker": "MCR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 10
        },
        {
          "asset_id": 60,
          "asset_name": "MFS Intermediate Income Trust",
          "asset_ticker": "MIN",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 11
        },
        {
          "asset_id": 61,
          "asset_name": "MFS Multimarket Income Trust",
          "asset_ticker": "MMT",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 12
        },
        {
          "asset_id": 62,
          "asset_name": "Putnam Intermediate Income Trust",
          "asset_ticker": "PIM",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 13
        },
        {
          "asset_id": 63,
          "asset_name": "Aberdeen Asia-Pacific Income Fund",
          "asset_ticker": "FAX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 14
        },
        {
          "asset_id": 64,
          "asset_name": "BlackRock Income Trust",
          "asset_ticker": "BKT",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 15
        },
        {
          "asset_id": 65,
          "asset_name": "Invesco Bond Fund",
          "asset_ticker": "VBF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 16
        },
        {
          "asset_id": 66,
          "asset_name": "Eaton Vance Ltd Duration Income Fund",
          "asset_ticker": "EVV",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 17
        },
        {
          "asset_id": 67,
          "asset_name": "BlackRock Debt Strategies Fund, Inc.",
          "asset_ticker": "DSU",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 18
        }
      ]
    },
    {
      "category_id": 8,
      "category_name": "Business Development Companies",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 68,
          "asset_name": "BlackRock Capital Investment Corp",
          "asset_ticker": "BKCC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 69,
          "asset_name": "Whitehorse Finance",
          "asset_ticker": "WHF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 70,
          "asset_name": "Stellus Capital Investments",
          "asset_ticker": "SCM",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 71,
          "asset_name": "TPG Specialty Lending",
          "asset_ticker": "TSLX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 72,
          "asset_name": "FS KKR Capital Corp",
          "asset_ticker": "FSK",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        },
        {
          "asset_id": 73,
          "asset_name": "Barings BDC Inc.",
          "asset_ticker": "BBDC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 6
        },
        {
          "asset_id": 74,
          "asset_name": "Prospect Capital Corp",
          "asset_ticker": "PSEC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 7
        },
        {
          "asset_id": 75,
          "asset_name": "MidCap Financial Investment Corp",
          "asset_ticker": "MFIC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 8
        },
        {
          "asset_id": 76,
          "asset_name": "Ares Capital Corp",
          "asset_ticker": "ARCC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 9
        },
        {
          "asset_id": 77,
          "asset_name": "Capital Southwest Corp",
          "asset_ticker": "CSWC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 10
        },
        {
          "asset_id": 78,
          "asset_name": "Gladstone Investment Corp",
          "asset_ticker": "GAIN",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 11
        },
        {
          "asset_id": 79,
          "asset_name": "Hercules Technology Growth Capital",
          "asset_ticker": "HTGC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 12
        },
        {
          "asset_id": 80,
          "asset_name": "Main Street Capital Corp",
          "asset_ticker": "MAIN",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 13
        },
        {
          "asset_id": 81,
          "asset_name": "Oaktree Specialty Lending Corp",
          "asset_ticker": "OCSL",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 14
        },
        {
          "asset_id": 82,
          "asset_name": "Saratoga Investment Corp",
          "asset_ticker": "SAR",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 15
        },
        {
          "asset_id": 83,
          "asset_name": "Monroe Capital Corp",
          "asset_ticker": "MRCC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 16
        },
        {
          "asset_id": 84,
          "asset_name": "TCG BDC, Inc.",
          "asset_ticker": "CGBD",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 17
        },
        {
          "asset_id": 85,
          "asset_name": "Oxford Square Capital Corp",
          "asset_ticker": "OXSQ",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 18
        },
        {
          "asset_id": 86,
          "asset_name": "Investcorp Credit Management",
          "asset_ticker": "ICMB",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 19
        },
        {
          "asset_id": 87,
          "asset_name": "TCP Capital Corp",
          "asset_ticker": "TCPC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 20
        },
        {
          "asset_id": 88,
          "asset_name": "Portman Ridge Finance Corporation",
          "asset_ticker": "PTMN",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 21
        },
        {
          "asset_id": 89,
          "asset_name": "Crescent Capital BDC",
          "asset_ticker": "CCAP",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 22
        },
        {
          "asset_id": 90,
          "asset_name": "Goldman Sachs BDC Inc",
          "asset_ticker": "GSBD",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 23
        },
        {
          "asset_id": 91,
          "asset_name": "TriplePoint Venture Growth BDC Corp",
          "asset_ticker": "TPVG",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 24
        },
        {
          "asset_id": 92,
          "asset_name": "Bain Capital Specialty Finance",
          "asset_ticker": "BCSF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 25
        },
        {
          "asset_id": 93,
          "asset_name": "PennantPark Investment Corporation",
          "asset_ticker": "PNNT",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 26
        },
        {
          "asset_id": 94,
          "asset_name": "SLR Investment Corp",
          "asset_ticker": "SLRC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 27
        },
        {
          "asset_id": 95,
          "asset_name": "OFS Capital Corp",
          "asset_ticker": "OFS",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 28
        },
        {
          "asset_id": 96,
          "asset_name": "Fidus Investment Corp",
          "asset_ticker": "FDUS",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 29
        },
        {
          "asset_id": 97,
          "asset_name": "Owl Rock Capital",
          "asset_ticker": "ORCC",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 30
        }
      ]
    },
    {
      "category_id": 9,
      "category_name": "Alternative Investment Strategies",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 98,
          "asset_name": "Convertible Arbitrage",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 99,
          "asset_name": "Equity Market Neutral",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 100,
          "asset_name": "Event Driven",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 101,
          "asset_name": "Fixed Income Arbitrage",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 102,
          "asset_name": "Global Macro",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        },
        {
          "asset_id": 103,
          "asset_name": "Long/Short Equity",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 6
        },
        {
          "asset_id": 104,
          "asset_name": "Merger Arbitrage",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 7
        },
        {
          "asset_id": 105,
          "asset_name": "Multi-Strategy",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 8
        },
        {
          "asset_id": 106,
          "asset_name": "Managed Futures",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 9
        }
      ]
    },
    {
      "category_id": 10,
      "category_name": "Chapwood Managed Accounts",
      "category_percentage": 0,
      "category_value": 0,
      "assets": [
        {
          "asset_id": 115,
          "asset_name": "Emancipation Long/Short Equity",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 1
        },
        {
          "asset_id": 116,
          "asset_name": "Pawleys Dividend",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 2
        },
        {
          "asset_id": 117,
          "asset_name": "Pawleys Growth",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 3
        },
        {
          "asset_id": 118,
          "asset_name": "Pinnacle 130/30",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 4
        },
        {
          "asset_id": 119,
          "asset_name": "Van Hulzen Covered Call",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 5
        },
        {
          "asset_id": 120,
          "asset_name": "Millennium",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 6
        },
        {
          "asset_id": 121,
          "asset_name": "Hudson Bay",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 7
        },
        {
          "asset_id": 122,
          "asset_name": "Elliott",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 8
        },
        {
          "asset_id": 123,
          "asset_name": "Third Point",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 9
        },
        {
          "asset_id": 124,
          "asset_name": "DE Shaw Composite",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 10
        },
        {
          "asset_id": 125,
          "asset_name": "DE Shaw Oculus",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 11
        },
        {
          "asset_id": 126,
          "asset_name": "Warrington Strategic",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 12
        },
        {
          "asset_id": 127,
          "asset_name": "Apollo Global Management Traditional Private Equity",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 13
        },
        {
          "asset_id": 128,
          "asset_name": "Providence Equity Partner Funds",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 14
        },
        {
          "asset_id": 129,
          "asset_name": "Kona Funds",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 15
        },
        {
          "asset_id": 130,
          "asset_name": "Vista Flagship Funds",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 16
        },
        {
          "asset_id": 131,
          "asset_name": "The Rama Fund",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 17
        },
        {
          "asset_id": 132,
          "asset_name": "ABR 75/25",
          "asset_ticker": "VOLSX",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 18
        },
        {
          "asset_id": 133,
          "asset_name": "Warrington Tactical",
          "asset_ticker": "N/A",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 19
        },
        {
          "asset_id": 134,
          "asset_name": "Pacer US Cash Cows 100 ETF",
          "asset_ticker": "COWZ",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 20
        },
        {
          "asset_id": 135,
          "asset_name": "Pacer US Small Cap Cash Cows 100 ETF",
          "asset_ticker": "CALF",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 21
        },
        {
          "asset_id": 136,
          "asset_name": "Pacer Developed Markets International Cash Cows 10",
          "asset_ticker": "ICOW",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 22
        },
        {
          "asset_id": 137,
          "asset_name": "Pacer Funds Trust - Pacer Global Cash Cows Dividen",
          "asset_ticker": "GCOW",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 23
        },
        {
          "asset_id": 138,
          "asset_name": "Pacer Emerging Markets Cash Cows 100 ETF",
          "asset_ticker": "ECOW",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 24
        },
        {
          "asset_id": 139,
          "asset_name": "Pacer US Cash Cows Growth ETF",
          "asset_ticker": "BUL",
          "asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 25
        },
				{
					"asset_id": 140,
					"asset_name": "The Ambassador Fund",
					"asset_ticker": "N/A",
					"asset_percentage": 0,
          "asset_value": 0, 
          "display_order": 26
				}
		  ]
	  }
	]
}

export const STATISTIC_DATA: Statistic[] = [
	{ metric: 'Rate of Return', value: 'N/A' },
	{ metric: 'Standard Deviation', value: 'N/A' },
	{ metric: 'Variance Drag Phantom Tax', value: 'N/A' },
	{ metric: 'Sharpe Ratio', value: 'N/A' },
	{ metric: 'Probability of Any Loss in the Next 12 Months', value: 'N/A' },
	{ metric: 'Amount of Money at Risk in the Next 12 Months', value: 'N/A' },
	{ metric: 'Upper Return', value: 'N/A' },
	{ metric: 'Lower Return', value: 'N/A' },
	{ metric: 'Beta to the S&P 500', value: 'N/A' },
	{ metric: 'Upside Capture Ratio', value: 'N/A' },
	{ metric: 'Downside Capture Ratio', value: 'N/A' },
];

export const PORTFOLIO_BREAKDOWN: PortfolioBreakdown = {
	portfolio_rate_of_return: 0.10,
	portfolio_standard_deviation: 0.05,
	portfolio_correlation: 0.28,
	portfolio_value: 3500000,
	portfolio_percentage: 1,
	categoryBreakdowns: [
		{ category_name: 'Senior Rate Floating Notes', category_rate_of_return: 0.05, category_standard_deviation: 0.02, category_correlation: 0.54, category_percentage: 0.25, category_value: 875000, assetBreakdowns: [{ asset_name: 'Eaton Vance Ltd Duration Income Fund', asset_ticker: 'ETVLTD', asset_rate_of_return: 0.10, asset_standard_deviation: 0.05, asset_correlation: 0.35, asset_percentage: 0.25, asset_value: 875000 }], isExpanded: true },
		{ category_name: 'Chapwood Managed Accounts', category_rate_of_return: 0.08, category_standard_deviation: 0.01, category_correlation: 0.23, category_percentage: 0.75, category_value: 2625000, assetBreakdowns: [{ asset_name: 'Cognios Market Neutral', asset_ticker: 'N/A', asset_rate_of_return: 0.05, asset_standard_deviation: 0.01, asset_correlation: 0.15, asset_percentage: 0.25, asset_value: 875000 }, { asset_name: 'The Rama Fund', asset_ticker: 'N/A', asset_rate_of_return: 0.07, asset_standard_deviation: 0.02, asset_correlation: 0.28, asset_percentage: 0.50, asset_value: 1750000 }], isExpanded: true }

	]
}
export const TEN_YEAR_DATA: any[] = [
	{ year: '2011', value: '1500000' },
	{ year: '2012', value: '1650000' },
	{ year: '2013', value: '1670000' },
	{ year: '2014', value: '1840000' },
	{ year: '2015', value: '2100000' },
	{ year: '2016', value: '2530000' },
	{ year: '2017', value: '2600000' },
	{ year: '2018', value: '2800000' },
	{ year: '2019', value: '2930000' },
	{ year: '2020', value: '3050000' },
]
